import emailjs from '@emailjs/browser';

// EmailJS configuration - set these in your .env file
const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || '';
const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || '';
const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || '';

// Initialize EmailJS
if (EMAILJS_PUBLIC_KEY) {
  emailjs.init(EMAILJS_PUBLIC_KEY);
}

export interface WelcomeEmailParams {
  to_email: string;
  to_name: string;
  welcome_url: string;
  from_name?: string;
}

export const sendWelcomeEmail = async (params: WelcomeEmailParams): Promise<void> => {
  console.log('EmailJS Config Check:', {
    serviceId: EMAILJS_SERVICE_ID ? '[SET]' : '[NOT SET]',
    templateId: EMAILJS_TEMPLATE_ID ? '[SET]' : '[NOT SET]',
    publicKey: EMAILJS_PUBLIC_KEY ? '[SET]' : '[NOT SET]',
  });

  if (!EMAILJS_SERVICE_ID || !EMAILJS_TEMPLATE_ID || !EMAILJS_PUBLIC_KEY) {
    console.warn('EmailJS configuration is incomplete. Email will not be sent.');
    console.warn('Missing:', {
      serviceId: !EMAILJS_SERVICE_ID,
      templateId: !EMAILJS_TEMPLATE_ID,
      publicKey: !EMAILJS_PUBLIC_KEY,
    });
    return;
  }

  try {
    console.log(`Sending welcome email to ${params.to_email} via EmailJS`);
    
    const templateParams = {
      to_email: params.to_email,
      to_name: params.to_name,
      welcome_url: params.welcome_url,
      from_name: params.from_name || 'SuperGauge Team',
      subject: 'Welcome to SuperGauge',
    };

    console.log('Template params:', templateParams);

    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      templateParams
    );

    console.log('Welcome email sent successfully:', response.status, response.text);
  } catch (error) {
    console.error('Failed to send welcome email:', error);
    throw error;
  }
};
